import {IBusinessUnit} from './ibusiness-unit';
import {BaseBusinessUnit} from './base-business-unit';


export class HrBusinessUnit extends BaseBusinessUnit implements IBusinessUnit {

}



// WEBPACK FOOTER //
// ./src/app/models/game/company/business-units/hr-business-unit.ts